@if (showBanner) {
<div
  #bannerEl
  [attr.popover]="'manual'"
  class="kh-cookie-consent-banner"
  [class.kh-cookie-consent-banner--student]="isStudentApp"
  role="dialog"
  aria-modal="false"
  [attr.aria-label]="'COOKIE_CONSENT.ARIA_LABEL' | translate"
  aria-labelledby="cookie-consent-title"
  aria-describedby="cookie-consent-message"
  tabindex="-1"
  data-testid="cookie-consent-banner"
>
  <div class="banner-copy">
    <h2 id="cookie-consent-title" class="banner-title">
      {{ 'COOKIE_CONSENT.TITLE' | translate }}
    </h2>

    <ng-template #privacyPolicy>
      <a
        [href]="'COOKIE_CONSENT.PRIVACY_POLICY_URL' | translate"
        target="_blank"
        rel="noopener noreferrer"
        class="banner-link"
        [attr.aria-label]="'COOKIE_CONSENT.PRIVACY_POLICY_ARIA' | translate"
      >
        {{ 'COOKIE_CONSENT.MESSAGE_PARTS.PRIVACY_POLICY' | translate }}
      </a>
    </ng-template>

    <p
      id="cookie-consent-message"
      class="banner-text"
      [translateWithFormat]="'COOKIE_CONSENT.MESSAGE_PARTS.KH_MESSAGE_FORMAT'"
      [templateParams]="{ privacyPolicy: privacyPolicy }"
    ></p>
  </div>

  <button
    type="button"
    class="banner-btn"
    data-testid="cookie-consent-acknowledge-button"
    (click)="onAcknowledge()"
    [attr.aria-label]="'COOKIE_CONSENT.OK_ARIA' | translate"
  >
    {{ 'COOKIE_CONSENT.OK_BUTTON' | translate }}
  </button>
</div>
}